"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_client_1 = __importDefault(require("apollo-client"));
var apollo_link_1 = require("apollo-link");
var DefaultCache_1 = require("./DefaultCache");
function createDefaultApolloClient() {
    var links = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        links[_i] = arguments[_i];
    }
    return new apollo_client_1.default({
        cache: DefaultCache_1.createDefaultCache(),
        link: apollo_link_1.ApolloLink.from(links),
    });
}
exports.createDefaultApolloClient = createDefaultApolloClient;
//# sourceMappingURL=DefaultApolloClient.js.map